import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Formsy from "formsy-react";
import Input from "./FormsyControlledInput";
import CustomNumberFormat from "./CustomNumberFormat";

Formsy.addValidationRule("maxAmountValidation", (values, value, max_amount) => {
  max_amount = parseInt(max_amount, 10);
  if (isNaN(max_amount)) {
    max_amount = 0;
  }

  value = parseInt(value.replace(/,/g, "").replace("$", ""), 10);
  if (isNaN(value)) {
    value = 0;
  }

  if (value > max_amount) {
    return "Value cannot exceed " + max_amount;
  }

  return true;
});

Formsy.addValidationRule("isNumericCustom", (values, value) => {
  value = parseInt(value.replace(/,/g, "").replace("$", ""), 10);

  if (isNaN(value)) {
    return false;
  }

  if (typeof value === "number") {
    return true;
  }

  return (
    !(value !== null && value !== undefined) ||
    value === "" ||
    /^[-+]?(?:\d*[.])?\d+$/.test(value)
  );
});

class AbbreviateNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onChangeCallback: props.onChange,
      maxAmount: props.maxAmount || null
    };
  }

  abbreviateNum(number) {
    return number > 99999 ? (number / 1000000).toFixed(2) + "M" : number;
  }

  abbreviateNegativeNum(number) {
    return number < 99999 ? ((number / 1000000) * -1).toFixed(2) + "M" : number;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      maxAmount: nextProps.maxAmount || null
    });
  }

  render() {
    const type = this.props.type || "text";
    const value = this.props.value;
    const name = this.props.name || "sampleName";
    const prexfixFromProp = this.props.prefix;
    let prefix = prexfixFromProp === "" ? "" : "$";
    if (typeof this.props.prefix !== "undefined") {
      prefix = this.props.prefix;
    }

    let suffix = '';
    if (typeof this.props.suffix !== "undefined") {
      suffix = this.props.suffix;
    }
    const disabled = this.props.disabled;

    if (value < 99999 && type === "input") {
      if (this.state.onChangeCallback) {
        if (
          typeof this.props.maxAmount !== "undefined" &&
          this.props.maxAmount >= 0
        ) {
          return (
            <CustomNumberFormat
              customInput={Input}
              name={name}
              value={value}
              type="text"
              validations={{
                isNumericCustom: true,
                maxAmountValidation: this.state.maxAmount
              }}
              validationErrors={{
                isNumericCustom: "Only numeric values supported"
              }}
              labelClassName={[{ "col-sm-3": false }, "hidden"]}
              elementWrapperClassName={["col-sm-9", "custom-error-size"]}
              validateOnSubmit={true}
              prefix={prefix}
              suffix={suffix}
              thousandSeparator=","
              onChange={this.state.onChangeCallback}
            />
          );
        } else {
          return (
            <NumberFormat
              value={value}
              displayType={type}
              prefix={prefix}
              suffix={suffix}
              thousandSeparator=","
              onChange={this.state.onChangeCallback}
              disabled={disabled}
            />
          );
        }
      } else {
        if (
          typeof this.props.maxAmount !== "undefined" &&
          this.props.maxAmount >= 0
        ) {
          return (
            <CustomNumberFormat
              customInput={Input}
              name={name}
              value={value}
              type="text"
              validations={{
                isNumericCustom: true,
                maxAmountValidation: this.state.maxAmount
              }}
              validationErrors={{
                isNumericCustom: "Only numeric values supported"
              }}
              labelClassName={[{ "col-sm-3": false }, "hidden"]}
              elementWrapperClassName={["col-sm-9", "custom-error-size"]}
              validateOnSubmit={true}
              prefix={prefix}
              thousandSeparator=","
            />
          );
        } else {
          return (
            <NumberFormat
              value={value}
              displayType={type}
              prefix={prefix}
              thousandSeparator=","
            />
          );
        }
      }
    }

    if (value < 99999 && type === "text") {
      return <span>-${this.abbreviateNegativeNum(value)}</span>;
    }

    if (type === "text" && value > 99999) {
      return <span>${this.abbreviateNum(value)}</span>;
    }

    if (this.state.onChangeCallback) {
      if (
        typeof this.props.maxAmount !== "undefined" &&
        this.props.maxAmount >= 0
      ) {
        return (
          <CustomNumberFormat
            customInput={Input}
            name={name}
            value={value}
            type="text"
            validations={{
              isNumericCustom: true,
              maxAmountValidation: this.state.maxAmount
            }}
            validationErrors={{
              isNumericCustom: "Only numeric values supported"
            }}
            labelClassName={[{ "col-sm-3": false }, "hidden"]}
            elementWrapperClassName={["col-sm-9", "custom-error-size"]}
            validateOnSubmit={true}
            prefix={prefix}
            thousandSeparator=","
            onChange={this.state.onChangeCallback}
          />
        );
      } else {
        return (
          <NumberFormat
            value={value}
            displayType={type}
            prefix={prefix}
            thousandSeparator=","
            onChange={this.state.onChangeCallback}
          />
        );
      }
    } else {
      if (
        typeof this.props.maxAmount !== "undefined" &&
        this.props.maxAmount >= 0
      ) {
        return (
          <CustomNumberFormat
            customInput={Input}
            name={name}
            value={value}
            type="text"
            validations={{
              isNumericCustom: true,
              maxAmountValidation: this.state.maxAmount
            }}
            validationErrors={{
              isNumericCustom: "Only numeric values supported"
            }}
            labelClassName={[{ "col-sm-3": false }, "hidden"]}
            elementWrapperClassName={["col-sm-9", "custom-error-size"]}
            validateOnSubmit={true}
            prefix={prefix}
            thousandSeparator=","
          />
        );
      } else {
        return (
          <NumberFormat
            value={value}
            displayType={type}
            prefix={prefix}
            thousandSeparator=","
          />
        );
      }
    }
  }
}

export default AbbreviateNumber;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/numbers/AbbreviateNumber.js